(function () {
  var all = document.querySelectorAll('[data-pmq]:not(.is-ready)');
  var pmq = all[all.length - 1];
  if (!pmq) return;
  var track = pmq.querySelector('[data-pmq-track]');
  if (!track || track.children.length < 4) return;
  var items = Array.prototype.slice.call(track.children);
  for (var i = items.length - 1; i > 0; i--) {
    var j = Math.floor(Math.random() * (i + 1));
    var t = items[i]; items[i] = items[j]; items[j] = t;
  }
  items.forEach(function (el) { track.appendChild(el); });
  items.forEach(function (el) {
    var c = el.cloneNode(true);
    c.setAttribute('aria-hidden', 'true');
    c.setAttribute('tabindex', '-1');
    track.appendChild(c);
  });
  pmq.classList.add('is-ready');

  /* ---- Movimiento continuo por JS (scrollLeft) + arrastre/deslizamiento del cliente ---- */
  var VEL = 38;                       // píxeles por segundo
  var reducir = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var pausadoHasta = 0, ultimo = null, activo = true, arrastrando = false, x0 = 0, s0 = 0, movio = false;
  var pos = 1;                        // posición con decimales (scrollLeft redondea y perdería los 0,6 px por cuadro)
  /* 17-oct-2026 (velocidad): el ancho se mide una vez y solo se vuelve a medir si la pista cambia de tamaño;
     antes se leía scrollWidth en cada cuadro (60 veces por segundo), lo que obligaba al navegador a recalcular. */
  var mitadCache = 0;
  function mitad() { return mitadCache || (mitadCache = track.scrollWidth / 2); }
  if ('ResizeObserver' in window) new ResizeObserver(function () { mitadCache = 0; }).observe(track);
  else window.addEventListener('resize', function () { mitadCache = 0; }, { passive: true });
  function fijar(v) {                 // bucle infinito: el contenido está duplicado, se salta media pista sin que se note
    var m = mitad(); if (m) { while (v >= m) v -= m; while (v < 1) v += m; }
    pos = v; pmq.scrollLeft = v;
  }
  /* Solo se anima mientras la tira está en pantalla y la pestaña visible: fuera de vista no gasta procesador. */
  var visible = true, corriendo = false;
  function paso(ts) {
    if (!visible || document.hidden) { corriendo = false; ultimo = null; return; }
    if (ultimo === null) ultimo = ts;
    var dt = Math.min(64, ts - ultimo); ultimo = ts;
    if (activo && !reducir && ts > pausadoHasta && !arrastrando) fijar(pos + VEL * dt / 1000);
    requestAnimationFrame(paso);
  }
  function pausar(ms) { pausadoHasta = performance.now() + (ms || 2500); }
  // Si el cliente movió la tira (dedo, rueda…), se sincroniza la posición y se mantiene el bucle
  pmq.addEventListener('scroll', function () {
    var sl = pmq.scrollLeft; if (Math.abs(sl - pos) <= 2) return;       // fue nuestro propio avance
    var m = mitad(); if (m && (sl >= m || sl < 1)) fijar(sl); else pos = sl;
  }, { passive: true });
  pmq.addEventListener('mouseenter', function () { activo = false; });
  pmq.addEventListener('mouseleave', function () { activo = true; });
  pmq.addEventListener('touchstart', function () { pausar(4000); }, { passive: true });
  pmq.addEventListener('touchend', function () { pausar(2500); }, { passive: true });
  pmq.addEventListener('wheel', function () { pausar(2500); }, { passive: true });
  // Arrastre con el mouse (en pantallas táctiles el deslizamiento es nativo)
  pmq.addEventListener('pointerdown', function (e) {
    if (e.pointerType !== 'mouse') return;
    arrastrando = true; movio = false; x0 = e.clientX; s0 = pmq.scrollLeft; pmq.classList.add('is-drag');
    try { pmq.setPointerCapture(e.pointerId); } catch (_) {}
  });
  pmq.addEventListener('pointermove', function (e) {
    if (!arrastrando) return;
    var dx = e.clientX - x0; if (Math.abs(dx) > 5) movio = true;
    var v = s0 - dx, m = mitad();
    if (m && v >= m) { v -= m; s0 -= m; } else if (m && v < 1) { v += m; s0 += m; }
    pos = v; pmq.scrollLeft = v;
  });
  function soltar() { if (!arrastrando) return; arrastrando = false; pmq.classList.remove('is-drag'); pausar(2000); }
  pmq.addEventListener('pointerup', soltar); pmq.addEventListener('pointercancel', soltar); pmq.addEventListener('lostpointercapture', soltar);
  pmq.addEventListener('click', function (e) { if (movio) { e.preventDefault(); e.stopPropagation(); movio = false; } }, true);
  pmq.addEventListener('dragstart', function (e) { e.preventDefault(); });
  function arrancar() { if (!corriendo && !reducir && visible && !document.hidden) { corriendo = true; ultimo = null; requestAnimationFrame(paso); } }
  if ('IntersectionObserver' in window) {
    new IntersectionObserver(function (es) { visible = es[0].isIntersecting; if (visible) arrancar(); }, { rootMargin: '150px 0px' }).observe(pmq);
  }
  document.addEventListener('visibilitychange', arrancar);
  fijar(1);
  arrancar();
})();
